module.exports = __webpack_public_path__ + "media/images/icons/outlined/solution-55dbba5dca375e2425780b7a8608427a.svg";